<article class="landing-card" [class.landing-card-white]="variant === 'white'">
  <div class="landing-card-top">
    <span class="landing-card-code">{{ formCode(form.number) }}</span>
    <button type="button" class="landing-card-action" (click)="open.emit(form)">
      Abrir
      <span class="material-icons">open_in_new</span>
    </button>
  </div>
  <p>{{ form.title }}</p>
  <p class="landing-card-subtitle" *ngIf="form.subtitle">{{ form.subtitle }}</p>
  <p class="landing-card-number">{{ form.number }}</p>
</article>
